import { createContext } from "react";

export const ResponsiveContext = createContext(undefined);
